import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../../store/actions";
import { useLocation } from 'react-router-dom';

import "../datatables.scss"
import { PAGECODE, PAGEPATHS, PAGEDISPLAYNAMES, getAccessManagementPages, USERTYPES } from "components/Common/Constant/index";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { showToaster } from "components/Common/common";

const DatatableTables = (props) => {
  const location = useLocation();
  const { user: details } = location.state || {};
  const [isUpdated, setIsUpdated] = useState(false)

  document.title = "Access Management";
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "User Management", link: PAGEPATHS.Usermanage },
    { title: "Access Management", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems('Access Management', breadcrumbItems)
  })

  const handlePermission = (perm, page, e) => {
    const value = PAGECODE[page];
    const isChecked = e.target.checked;

    let newRead = [...details.permissions.read];
    let newWrite = [...details.permissions.write];

    if (perm === false) {
      if (isChecked) {
        newRead = newRead.filter(p => p !== value);
        newWrite = newWrite.filter(p => p !== value);
      }
    } else if (perm === 'read') {
      if (isChecked) {
        if (!newRead.includes(value)) newRead.push(value);
      } else {
        newRead = newRead.filter(p => p !== value);
        newWrite = newWrite.filter(p => p !== value);
      }
    } else if (perm === 'write') {
      if (isChecked) {
        if (!newWrite.includes(value)) newWrite.push(value);
        if (!newRead.includes(value)) newRead.push(value);
      } else {
        newWrite = newWrite.filter(p => p !== value);
      }
    }

    details.permissions.read = newRead;
    details.permissions.write = newWrite;
    updateUserDetail();
    setIsUpdated(true);
  };

  const updateUserDetail = () => {
    // Get available pages for this user type
    const availablePages = getAccessManagementPages(details.userType, details.permissions);

    // Filter PAGECODE to only show pages available to this user type
    const allowedPageKeys = Object.keys(PAGECODE).filter(k =>
      availablePages.includes(PAGECODE[k])
    );

    const format = allowedPageKeys.reduce((a, k) => {
      const data = {
        pagename: PAGEDISPLAYNAMES[k] || k, // Use display name if available, otherwise fallback to key
        readonly: (<div className="text-center"> <input onClick={(e) => handlePermission('read', k, e)} checked={details.permissions.read.includes(PAGECODE[k])} type="checkbox" /> </div>),
        writeonly: (<div className="text-center"> <input onClick={(e) => handlePermission('write', k, e)} checked={details.permissions.write.includes(PAGECODE[k])} type="checkbox" /> </div>),
        notavailable: (<div className="text-center"> <input onClick={(e) => handlePermission(false, k, e)} checked={!details.permissions.read.includes(PAGECODE[k]) && !details.permissions.write.includes(PAGECODE[k])} type="checkbox" /> </div>),
      }
      a.push(data)
      return a
    }, [])

    setData((pre) => ({
      ...pre,
      columns: pre.columns,
      rows: format
    }))
  }

  useEffect(() => {
    if (!details) {
      navigate(PAGEPATHS.Usermanage)
      return
    }
    // Auto-grant SSP Studio (29) read + write access for standard users if not already set
    if (details.userType === USERTYPES.Standard) {
      if (!details.permissions.read.includes(29)) details.permissions.read.push(29);
      if (!details.permissions.write.includes(29)) details.permissions.write.push(29);
    }
    updateUserDetail()
  }, [])

  const updateUserData = async () => {
    try {
      console.log('=== Access Management Update ===');
      console.log('details object:', details);
      console.log('details.firstname:', details.firstname);
      console.log('details.FirstName:', details.FirstName);
      console.log('details.lastname:', details.lastname);
      console.log('details.LastName:', details.LastName);

      const payload = {
        permissions: details.permissions,
        firstname: details.firstname || details.FirstName,
        lastname: details.lastname || details.LastName,
      }

      console.log('Payload being sent:', payload);

      const { data } = await axiosInstance
        .put(`${ApiNames.USER_UPDATE}/${details._id}`,
          payload,
          {
            headers: {
              "if-match": details.__v
            }
          }
        )

      if (data.status === 1) {
        showToaster(data.status, "Permissions updated");
        navigate(PAGEPATHS.Usermanage)
      }
    } catch (e) {
      console.error('Update error:', e);

    }
  }

  const [data, setData] = useState({
    columns: [
      {
        label: "Page Name",
        field: "pagename",
        sort: "asc",
        width: 150,
      },
      {
        label: "Read Only",
        field: "readonly",
        sort: "asc",
        width: 270,
      },
      {
        label: "Write Only",
        field: "writeonly",
        sort: "asc",
        width: 200,
      },
      {
        label: "Not Available",
        field: "notavailable",
        sort: "asc",
        width: 100,
      }
    ],
    rows: []
  })

  return (
    <React.Fragment>

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row>
                <div className="col-8">
                  <CardTitle className="h4">{`${details?.firstname}'s Access Management`}</CardTitle>
                  <p className="card-title-desc">
                    Manage your users and their authority over reports here.
                  </p>
                </div>
                <div className="col-4">
                  {isUpdated &&
                    <button
                      type="button"
                      className="waves-effect float-end d-flex align-items-center waves-light btn btn-orange"
                      style={{ fontSize: "0.9rem" }}
                      onClick={updateUserData}>
                      <i className="mdi mdi-content-save fw-bold font-size-17 pe-1"></i>{" "}
                      Save Changes
                    </button>
                  }
                </div>
              </Row>

              <MDBDataTable entries={50} paging={false} responsive striped data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables);
